import * as z from 'zod/v4';

import type { Coupon } from './Coupon.js';

export const couponIndexSchema = z.coerce.number().int().positive().brand<'CouponIndex'>();

export type CouponIndex = z.infer<typeof couponIndexSchema>;

/**
 * Checks if a value is a coupon index.
 *
 * @param value Value to check
 * @returns true if value is a coupon index
 */
export function getCouponIndex(value: unknown): value is CouponIndex {
  if (typeof value !== 'number') {
    return false;
  }

  if (value < 0) {
    return false;
  }

  return true;
}

/**
 * Function to convert a collection of coupons to a valid CouponIndex array.
 *
 * @param coupons List of coupons
 * @returns A branded number as couponIndex
 */
export function getCouponIndices(coupons: Coupon[]): CouponIndex[] {
  const couponIndexes = coupons.map((_, couponIndex) => couponIndex).filter((index) => getCouponIndex(index));

  return couponIndexes;
}
